import script from "./IframeBar.vue?vue&type=script&setup=true&lang=js"
export * from "./IframeBar.vue?vue&type=script&setup=true&lang=js"

import "./IframeBar.vue?vue&type=style&index=0&id=7e9a8030&lang=scss"

const __exports__ = script;

export default __exports__